import Table from '@eduzz/houston-ui/Table';
import Typography from '@eduzz/houston-ui/Typography';
import { Icon, Tooltip } from '@material-ui/core';
import moment from 'moment';
import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';
import Truncate from 'v2/components/Shared/TruncateText';
import WhatsAppLink from 'v2/components/Shared/WhatsAppLink';
import leadsService from 'v2/services/leads/list';
import tableService from 'v2/services/table';

const List = () => {
  useObservable(() => leadsService.load(), []);

  const [isLoading] = useObservable(() => tableService.isLoading(), []);
  const [leads] = useObservable(() => leadsService.getLeads(), []);
  const [pagination] = useObservable(() => leadsService.getPaginationResponse(), []);

  const onChangePerPage = useCallback(
    (per_page: number) => {
      leadsService.setPagination({ ...pagination, per_page, current_page: 1 });
    },
    [pagination]
  );

  const onChangePage = useCallback(
    (page: number) => {
      leadsService.setPagination({ ...pagination, current_page: page });
    },
    [pagination]
  );

  return (
    <Table id='leads_table' total={pagination?.total_items || 0} loading={isLoading}>
      <Table.Header>
        <Table.Column width={120}>Data</Table.Column>
        <Table.Column width={200}>Nome</Table.Column>
        <Table.Column width={250}>E-mail</Table.Column>
        <Table.Column width={200}>Telefone</Table.Column>
        <Table.Column width={140}>Campanha</Table.Column>
        <Table.Column width={250}>Produto</Table.Column>
        <Table.Column width={175}>Afiliado</Table.Column>
        <Table.Column width={100}>Fatura</Table.Column>
      </Table.Header>
      <Table.Body>
        {leads?.map((lead, index) => (
          <Table.Row key={lead.id} data={lead} index={index}>
            <Table.Cell>
              <Typography size='xxs'>{lead.created_at ? moment(lead.created_at).format('DD/MM/YYYY') : '-'}</Typography>
              <Typography size='xxs'>{lead.created_at ? moment(lead.created_at).format('HH:mm') : '-'}</Typography>
            </Table.Cell>
            <Table.Cell>
              <Typography size='xxs'>{lead.customer?.name ?? '-'}</Typography>
            </Table.Cell>
            <Table.Cell>
              <Typography size='xxs'>
                <Truncate count={30} final='...'>
                  {lead.email}
                </Truncate>
              </Typography>
            </Table.Cell>
            <Table.Cell>{lead?.customer?.cellphone ? <WhatsAppLink phone={lead.customer.cellphone} /> : lead.customer.telephone}</Table.Cell>
            <Table.Cell>{lead.campaign?.key ?? '-'}</Table.Cell>
            <Table.Cell>
              <div>
                <Typography size='xxs' weight='semibold'>
                  <Truncate count={30} final='...'>
                    {lead?.product?.title}
                  </Truncate>
                </Typography>
                <Typography size='xxs'>({lead?.product?.id || ''})</Typography>
              </div>
            </Table.Cell>
            <Table.Cell>{lead.affiliate?.name ?? '-'}</Table.Cell>
            <Table.Cell>
              {lead.abandonment && !lead.invoice_id && (
                <Tooltip placement='top' title='Abandono de carrinho'>
                  <Icon style={{ fontSize: 20 }}>remove_shopping_cart</Icon>
                </Tooltip>
              )}
              {!lead.abandonment && lead.invoice_id && <span>{lead.invoice_id}</span>}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      {!isLoading && (
        <Table.Pagination
          page={pagination?.current_page}
          perPage={pagination?.per_page}
          onChangePage={onChangePage}
          onChangePerPage={onChangePerPage}
          optionsPerPage='10,20,50,100,200,500'
        />
      )}
    </Table>
  );
};
export default List;
